<form (ngSubmit)="onSubmit()" [formGroup]="checkoutLoginForm">
  <h2>{{'loginForm.checkoutLogin' | cxTranslate}}</h2>
  <div class="form-group">
    <label>
      <span class="label-content">
        {{ 'loginForm.emailAddress.label' | cxTranslate }}
      </span>
      <input
        type="email"
        name="email"
        class="form-control"
        formControlName="email"
      />
      <cx-form-errors
        [control]="checkoutLoginForm.get('email')"
      ></cx-form-errors>
    </label>
  </div>
  <div class="form-group">
    <label>
      <span class="label-content">
        {{ 'loginForm.confirmEmail' | cxTranslate }}
      </span>
      <input
        type="email"
        name="emailConfirmation"
        class="form-control"
        formControlName="emailConfirmation"
      />
      <cx-form-errors
        [control]="checkoutLoginForm.get('emailConfirmation')"
      ></cx-form-errors>
    </label>
  </div>
  <button type="submit" class="btn btn-block btn-white">
    {{ 'loginForm.buttonText' | cxTranslate }}
  </button>
</form>
